import styles from './BillingInfoSection.module.scss';
import { CancelRenewSection } from 'src/v2/pages/subscription/components/CancelRenewSection';
import { useGetUser, useTeamInfo } from 'src/hooks';
import { Button } from 'src/v2/commonComponents/Button';
import { CreditCard } from '@phosphor-icons/react';
import { COMMON_ERROR_TEXT, SVG_SIZE_M } from 'src/constants';
import {
  AppRoutes,
  SubscriptionInfo,
  UserSettingsNestedRoutes,
} from 'src/types';
import { useLazyGetBillingPortalUrlQuery } from 'src/store/services';
import { toast } from 'react-toastify';

type BillingInfoSectionProps = {
  isAppleOrAmpPayment?: boolean;
  subscriptionInfo?: SubscriptionInfo;
};

export const BillingInfoSection = ({
  isAppleOrAmpPayment,
  subscriptionInfo,
}: BillingInfoSectionProps) => {
  const { isMember, isAdmin, isOwner } = useTeamInfo();
  const { isTeamsTier, user_id, isSubscribedTier, isOpenTier } = useGetUser();

  const [triggerGetSubscriptionUrl, { isLoading }] =
    useLazyGetBillingPortalUrlQuery();

  const isManageSubscriptionBillingHidden =
    !isSubscribedTier || (isTeamsTier && !isOwner) || isAppleOrAmpPayment;

  const handleManageSubscriptionBillingClick = async () => {
    if (subscriptionInfo?.source === 'paypal') {
      window.location.href = 'https://www.paypal.com';
      return;
    }

    try {
      const { data } = await triggerGetSubscriptionUrl({
        user_id: user_id,
        return_url: `${AppRoutes.MANAGE_ACCOUNT}/${UserSettingsNestedRoutes.SUBSCRIPTION}`,
      });
      const redirectUrl = data?.url;

      if (redirectUrl) {
        window.location.href = redirectUrl;
      }
    } catch (e) {
      toast.error(COMMON_ERROR_TEXT);
    }
  };

  return (
    <div className={styles.root}>
      <h4 className={styles.title}>Billing information</h4>
      <span className={styles.description}>
        Manage all your payment information, payment history and billing
        information via Stripe.
      </span>
      <div className={styles.buttonsRow}>
        {!isManageSubscriptionBillingHidden && (
          <Button
            className={styles.manageSubscriptionButton}
            color="secondary-outline"
            disabled={isLoading}
            onClick={handleManageSubscriptionBillingClick}
          >
            <CreditCard size={SVG_SIZE_M} />
            <span>Manage subscription billing</span>
          </Button>
        )}
        {!isMember && !isAdmin && !isOpenTier && <CancelRenewSection />}
      </div>
    </div>
  );
};
